import AdministrationOverview from './AdministrationOverview'
import enhance from './AdministrationOverview.enhancer'

export default enhance(AdministrationOverview)

export const adminColumns = [
  {
    width: 225, field: 'fullName', label: 'Name'
  },
  {
    width: 500, field: 'email', label: 'Email',
  },
  {
    width: '100%', 
    field: 'select', 
    selectable: true, 
    hideHeader: true,
    align: 'flex-end',
    format: 'expandBox',
    selectableLabel: 'Remove admin'
  }
]



// WEBPACK FOOTER //
// ./src/containers/organisation/AdministrationOverview/index.js